import { Component } from '@angular/core';

@Component({
  selector: 'pop-license-expired',
  templateUrl: './license-expired.component.html',
  styleUrls: ['./license-expired.component.less']
})
export class LicenseExpiredComponent {}
